import { InjectionToken } from "@angular/core";
import { CommissionBonusSchedulePort } from "./commission-bonus-schedule.port";

export const COMMISSION_BONUS_SCHEDULE_PORT =
  new InjectionToken<CommissionBonusSchedulePort>("COMMISSION_BONUS_SCHEDULE_PORT");
